import React from "react";
import { Box, Skeleton, Grid, Card, CardContent } from "@mui/material";
import { Col } from "reactstrap";

const ShipmentSkeleton = () => {
    return (
        <div className="row">
            <div className="col-12" >
                <div className="myCard">
                    <Skeleton variant="text" height={20} width="30%" />
                    {[...Array(3)].map((_, i) => (
                        <Skeleton key={i} variant="rounded" height={20} sx={{ my: 1 }} animation="wave" />
                    ))}
                </div>
            </div>
            <div className="col-xs-12 col-md-9 col-lg-8 pt-3">
                <div className="myCard">
                    <Skeleton variant="text" height={40} width="60%" animation="wave" />
                    <Skeleton variant="text" height={15} width="40%" />
                    <Skeleton variant="rounded" height={200} sx={{ my: 2 }} animation="wave" />
                    <Skeleton variant="text" height={25} width="70%" />
                    <Skeleton variant="text" height={20} width="50%" />
                </div>
            </div>

            <div className="col-xs-12 col-md-3 col-lg-4 pt-3">
                <div className="myCard">
                    <Skeleton variant="text" height={30} width="90%" />
                    <Skeleton variant="text" height={20} width="80%" />
                    <Skeleton variant="rounded" height={300} sx={{ my: 1 }} />
                    <Skeleton variant="text" height={45} width="70%" />
                </div>
            </div>
            <div className="col-12 pt-3" >
                <div className="myCard">
                    <Skeleton variant="text" height={20} width="30%" />
                    {[...Array(3)].map((_, i) => (
                        <Skeleton key={i} variant="rounded" height={20} sx={{ my: 1 }} animation="wave" />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ShipmentSkeleton;
